export default function CashbackIcon({ width = 24, height = 24, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      {...props}
    >
      <path
        fill="#232D34"
        d="M21.75 6H19.5v-.75a1.5 1.5 0 0 0-1.5-1.5H6a1.5 1.5 0 0 0-1.5 1.5V6H2.25a1.5 1.5 0 0 0-1.5 1.5V9a3.75 3.75 0 0 0 3.75 3.75h.342a7.512 7.512 0 0 0 6.408 5.213v2.287H9a.75.75 0 1 0 0 1.5h6a.75.75 0 1 0 0-1.5h-2.25v-2.29c2.994-.302 5.479-2.403 6.383-5.21h.367A3.75 3.75 0 0 0 23.25 9V7.5a1.5 1.5 0 0 0-1.5-1.5ZM4.5 11.25A2.25 2.25 0 0 1 2.25 9V7.5H4.5v3c0 .25.012.5.037.75H4.5ZM21.75 9a2.25 2.25 0 0 1-2.25 2.25h-.047c.03-.277.047-.556.047-.834V7.5h2.25V9Z"
      />
    </svg>
  );
}
